import React from 'react';
import './NotesModal.css';

const NotesModal = ({ notes, isOpen, onClose }) => {
  
  if (!isOpen) return null;

  const starCounts = [
    notes.nbrNote5,
    notes.nbrNote4,
    notes.nbrNote3,
    notes.nbrNote2,
    notes.nbrNote1
  ];

  const totalNotes = starCounts.reduce((sum, count) => sum + count, 0);

  const ratings = starCounts.map((count, index) => ({
    stars: 5 - index,
    count,
    percentage: totalNotes ? (count / totalNotes) * 100 : 0
  }));

  const averageRating = notes.moyenne ? notes.moyenne.toFixed(1) : '0.0';

  const getProgressColor = (stars) => {
    return stars >= 4 ? '#FFC107' : '#9E9E9E';
  };

  const getStarColor = (stars) => {
    return stars >= 4 ? '#FFC107' : '#9E9E9E';
  };

  const StarIcon = ({ color, size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );

  const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Détail des notes</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fermer">
            <CloseIcon />
          </button>
        </div>

        <div className="modal-body">
          <div className="rating-summary">
            <StarIcon color="#FFC107" size={32} />
            <h3 className="average-rating">
              {averageRating}
            </h3>
            <p className="total-reviews">
              {totalNotes} avis au total
            </p>
          </div>

          <div className="ratings-breakdown">
            {ratings.map((rating) => (
              <div key={rating.stars} className="rating-row">
                <div className="star-label">
                  <StarIcon
                    color={getStarColor(rating.stars)}
                    size={24}
                  />
                  <span className="star-number">
                    {rating.stars}
                  </span>
                </div>

                <div className="progress-container">
                  <div
                    className="progress-bar"
                    style={{
                      width: `${rating.percentage}%`,
                      backgroundColor: getProgressColor(rating.stars)
                    }}
                  />
                </div>

                <span className="rating-count">
                  {rating.count}
                </span>
                <span className="rating-percentage">
                  ({rating.percentage.toFixed(1)}%)
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesModal;